<div *ngFor="let error of errors" class="alert alert-warning" role="alert">
    {{ error }}
</div>

<!-- <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
    <div class="form-group row">
        <label class="col-sm-1" for="form_login_tenant">{{'login-screen.tenant' | translate}}:</label>
        <input type="text" class="form-control col-sm-3" id="form_login_tenant" name="tenant" required [(ngModel)]="login.tenant">
    </div>
    <div class="form-group row">
        <label for="form_login_username">{{'login-screen.username' | translate}}</label>
        <input type="text" class="form-control" id="form_login_username" name="username" required [(ngModel)]="login.username">
    </div>
    <div class="form-group row">
        <label for="form_login_password">{{'login-screen.password' | translate}}</label>
        <input type="password" class="form-control" id="form_login_password" name="password" required [(ngModel)]="login.password">
    </div>
    <button type="submit" class="btn btn-primary">{{'login-screen.login' | translate}}</button>
</form> -->

<div class="container">
    <div class="card card-container">
        <img id="profile-img" class="profile-img-card" src="../../../assets/avatar.png" />
        <p id="profile-name" class="profile-name-card"></p>
        <form (ngSubmit)="onSubmit()" #loginForm="ngForm">
            <div class="form-group row">
                <label class="col-sm-4" for="form_login_tenant">{{'login-screen.tenant' | translate}}:</label>
                <input type="text" class="form-control col-sm-8" id="form_login_tenant" name="tenant" required [(ngModel)]="login.tenant">
            </div>
            <div class="form-group row">
                <label class="col-sm-4" for="form_login_username">{{'login-screen.username' | translate}}:</label>
                <input type="text" class="form-control col-sm-8" id="form_login_username" name="username" required [(ngModel)]="login.username">
            </div>
            <div class="form-group row">
                <label class="col-sm-4" for="form_login_password">{{'login-screen.password' | translate}}:</label>
                <input type="password" class="form-control col-sm-8" id="form_login_password" name="password" required [(ngModel)]="login.password">
            </div>
            <button type="submit" class="btn btn-primary col-sm-3">{{'login-screen.login' | translate}}</button>
        </form>

    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/users/login-form/login-form.component.html